import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {ButtonControl} from '../../../models/uiArtefakt';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {EventService} from '../../../services/event.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';

@Component({
    selector: 'lv-navigation-button',
    templateUrl: './navigation-button.component.html',
    styleUrls: ['./navigation-button.component.scss'],
    standalone: false
})
export class NavigationButtonComponent implements OnInit, AfterViewInit {

  public isDisabled: boolean = false;
  public uiAusrichtung: UIAusrichtung;

  private _uiArtefakt: ButtonControl;

  constructor(private _eventService: EventService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): ButtonControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ButtonControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public onButtonClicked() {
    this._eventService.navigationButtonClicked$.next(this._uiArtefakt.SeitenID);
  }
}
